import Cookies from 'js-cookie'
import Api from '../../api'

const substation = Number(Cookies.get('_substation')) || null // 分站 多端统一

const state = {
  config: {},
  substation,
  dict: {},
  switchList: {}
};

const getters = {
  config: state => {
    return state.config
  },
  dict: state => {
    return state.dict
  },
  substation: state => state.substation,
  substationOpened: state => Boolean(state.dict.SITE_LIST && state.dict.SITE_LIST.length > 0),
  switchList: state => {
    return state.switchList
  }
};

const actions = {
  async setWebConfig(context, val) {
    const res = await Api.webConfig.getWebConfig();
    context.commit('setWebConfig', res);
  },
  setSubstation({ commit }, sub) {
    commit('SET_SUBSTATION', sub)
  },
  setDict({ commit }, val) {
    // 默认分站选择
    try {
      if (!substation && val.SITE_LIST && val.SITE_LIST.length > 0) {
        commit('SET_SUBSTATION', val.SITE_LIST[0].id)
      }
    } catch (error) {
    }

    commit('setDict', val);
  },
  async setSwitchList(context, val) {
    const res = await Api.webConfig.getSwitchList();
    context.commit('setSwitchList', res);
  }
};

const mutations = {
  setWebConfig(state, val) {
    state.config = val
  },
  SET_SUBSTATION(state, sub) {
    Cookies.set('_substation', sub || '', {
      expires: 365,
      path: '/',
      secure: false
    });
    state.substation = sub
  },
  setDict(state, val) {
    state.dict = val
  },
  setSwitchList(state, val) {
    state.switchList = val
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/config.js